var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasksDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_16105",
    "data-name": "Group 16105",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.106,
    height: 17.624,
    viewBox: "0 0 15.106 17.624",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8435",
    "data-name": "Rectangle 8435",
    width: 15.106,
    height: 17.624,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16104",
    "data-name": "Group 16104",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5876",
    "data-name": "Path 5876",
    d: "M8.812,2.518a.629.629,0,0,1-.629.629H6.924a.629.629,0,0,1,0-1.259H8.183a.629.629,0,0,1,.629.629m1.259,12.589a.629.629,0,0,0,.629-.629V9.441a.629.629,0,1,0-1.259,0v5.035a.629.629,0,0,0,.629.629m5.035-10.7V6.924a.629.629,0,0,1-.629.629h-.629v6.924A3.151,3.151,0,0,1,10.7,17.624H4.406a3.151,3.151,0,0,1-3.147-3.147V7.553H.629A.629.629,0,0,1,0,6.924V4.406a.629.629,0,0,1,.629-.629h.68A4.409,4.409,0,0,1,5.665,0H9.441A4.411,4.411,0,0,1,13.8,3.777h.677A.629.629,0,0,1,15.106,4.406ZM2.581,3.777h9.944A3.152,3.152,0,0,0,9.441,1.259H5.665A3.153,3.153,0,0,0,2.581,3.777M12.589,7.553H2.518v6.924a1.891,1.891,0,0,0,1.888,1.888H10.7a1.891,1.891,0,0,0,1.888-1.888ZM5.035,15.106a.629.629,0,0,0,.629-.629V9.441a.629.629,0,1,0-1.259,0v5.035a.629.629,0,0,0,.629.629m2.518,0a.629.629,0,0,0,.629-.629V9.441a.629.629,0,1,0-1.259,0v5.035a.629.629,0,0,0,.629.629",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasksDelete);
export default __webpack_public_path__ + "static/media/tasks-delete.0b1438d8aff624a4ba93f088ea019c37.svg";
export { ForwardRef as ReactComponent };